import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-fare-by-type',
  templateUrl: './fare-by-type.component.html',
})
export class FareByTypeComponent  {
  @Input() taxesByType: any;
  @Input() type: string;
  expand = false;

  toggleDetail() {
    this.expand = !this.expand;
  }

}
